<template>
  <div>
    <h1 class="h2 fw-bold text-center mb-5">Activities for "{{ tourPackage.noOfDay }}-Day {{ tourPackage.title }}"</h1>

    <table class="table table-sm table-nowrap card-table mt-4">
      <thead class="text-primary">
        <tr>
          <th width="40">Order</th>
          <th width="100">Day</th>
          <th width="250">Type</th>
          <th width="300">Location</th>
          <th width="200">Transport</th>
          <th width="150">Moment</th>
          <th width="100">Hours</th>
          <th width="40">Excluded</th>
          <th width="100">Price (USD)</th>
          <th>Actions</th>
        </tr>
      </thead>
      <draggable tag="tbody" v-model="activityData" group="DayByDay" @start="drag = true" @end="drag = false">
        <tr v-for="(item, index) in activityData" :key="index">
          <td class="text-center" style="min-width: 40px">
            <span><i class="icofont-drag text-danger" style="font-size: 1.40625rem"></i></span>
          </td>
          <td style="min-width: 100px" class="px-2">
            <select v-model="activityData[index].day" class="form-control form-control-sm">
              <option v-for="(day, index) in tourPackage.dayByDay" :key="index" :value="index">
                {{ day.day }}
              </option>
            </select>
          </td>
          <td style="min-width: 250px">
            <InputTagDropdownType :key="'type' + index" :inputData.sync="activityData[index].type" />
          </td>
          <td style="min-width: 300px">
            <label v-if="activityData[index].type.toLowerCase().includes('transfer')">From: </label
            ><InputTagDropdownLocation :key="'type' + index" :inputData.sync="activityData[index].location" />
            <label v-if="activityData[index].type.toLowerCase().includes('transfer')" class="mt-2">To:</label>
            <InputTagDropdownLocation
              v-if="activityData[index].type.toLowerCase().includes('transfer')"
              :key="'type1' + index"
              :inputData.sync="activityData[index].locationTo"
            />
          </td>
          <td style="min-width: 200px">
            <InputTagDropdownTransport :key="'type' + index" :inputData.sync="activityData[index].transport" />
          </td>
          <td style="min-width: 150px">
            <InputTagDropdownMoment :key="'type' + index" :inputData.sync="activityData[index].moment" />
          </td>
          <td style="min-width: 150px">
            <input v-model="activityData[index].hours" type="text" />
          </td>
          <td class="text-center" style="min-width: 40px">
            <input type="checkbox" v-model="activityData[index].optional" />
          </td>
          <td class="text-center" style="min-width: 100px">
            <input v-if="activityData[index].optional" type="number" v-model="activityData[index].price" />
          </td>
          <td>
            <button class="btn btn-success mr-2" @click="copyItem(index)">Copy</button>
            <button class="btn btn-danger mr-2" @click="deleteItem(index)">Delete</button>
            <button class="btn btn-info" @click="addItemAfter(index)">Add after</button>
          </td>
        </tr>
        <tr v-if="dragPreview != null" class="drag-preview" :style="dragStyle" ref="dragPreview">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </draggable>
    </table>
    <button class="btn btn-info my-3" @click="addItemNew()">Add new activity</button>
    <br />
    <button class="btn btn-info my-3" @click="saveActivity()">
      <span v-if="!isUpdate">&nbsp;&nbsp;Save&nbsp;&nbsp;</span>
      <span v-else>Saving...</span>
    </button>
    <div v-if="isError" class="text-danger">Failed to Save. Try Again !</div>
    <div v-if="isSaved" class="text-success">Successfully Saved !</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import InputTagDropdownType from "./InputTagDropdownType.vue";
import InputTagDropdownLocation from "./InputTagDropdownLocation.vue";
import InputTagDropdownMoment from "./InputTagDropdownMoment.vue";
import InputTagDropdownTransport from "./InputTagDropdownTransport.vue";

export default {
  name: "ActivityTable",

  components: {
    draggable,
    InputTagDropdownType,
    InputTagDropdownLocation,
    InputTagDropdownMoment,
    InputTagDropdownTransport,
  },

  data() {
    return {
      activityData: [],
      isUpdate: false,
      isError: false,
      dragPreview: null,
      x: 0,
      y: 0,
    };
  },

  computed: {
    ...mapGetters([
      "tourActivities",
      "tourPackage",
      "tourOtherActivities",
      "tourCities",
      "tourTransports",
      "packageActivity",
    ]),
    tourPackageId() {
      return this.$route.params.id;
    },
    dragStyle() {
      return {
        top: `${this.y}px`,
        left: `${this.x}px`,
      };
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await Promise.all([
        this.fetchTourActivities(),
        this.fetchTourOtherActivities(),
        this.fetchTourTransports(),
        this.fetchTourCities(),
        this.fetchTourPackage(this.tourPackageId),
        this.fetchPackageActivity(this.tourPackageId),
      ]);

      this.activityData = this.packageActivity.activities;

      if (this.activityData == undefined || this.activityData.length == 0) {
        this.activityData = [];
        this.addItemNew();
      }

      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions([
      "fetchTourActivities",
      "fetchPackageActivity",
      "fetchTourOtherActivities",
      "fetchTourPackage",
      "hideBarLoading",
      "fetchTourTransports",
      "fetchTourCities",
      "updatePackageActivity",
    ]),

    copyItem(index) {
      let currentItem = this.activityData[index];
      let newItem = {
        day: currentItem.day,
        type: currentItem.type,
        location: currentItem.location,
        transport: currentItem.transport,
        moment: currentItem.moment,
        hours: currentItem.hours,
        optional: currentItem.optional,
        price: currentItem.price,
      };
      this.activityData.splice(index, 0, newItem);
    },
    deleteItem(index) {
      this.activityData.splice(index, 1);
      if (this.activityData.length == 0)
        this.activityData.push({
          day: null,
          type: "",
          location: "",
          transport: "",
          moment: "",
          hours: "",
          optional: false,
          price: "",
        });
    },
    addItemAfter(index) {
      this.activityData.splice(index + 1, 0, {
        day: null,
        type: "",
        location: "",
        transport: "",
        moment: "",
        hours: "",
        optional: false,
        price: "",
      });
    },
    addItemNew() {
      this.activityData.push({
        day: null,
        type: "",
        location: "",
        transport: "",
        moment: "",
        hours: "",
        optional: false,
        price: "",
      });
    },

    async saveActivity() {
      console.log(this.activityData);
      const postData = {
        id: this.tourPackageId,
        activities: {
          package: parseInt(this.tourPackageId),
          activities: this.activityData,
        },
      };

      this.isUpdate = true;
      this.isError = false;
      this.isSaved = false;

      await this.updatePackageActivity(postData)
        .then((_res) => {
          this.isUpdate = false;
          this.isSaved = true;
        })
        .catch(() => {
          this.isError = true;
          this.isUpdate = false;
        });
    },
  },
};
</script>

<style scoped>
table td:first-child {
  cursor: grab;
}

.table tr td,
.table tr th {
  text-align: left;
  border: 1px solid #ccc;
  font-size: 0.8125rem;
  font-weight: 600;
}
.table:not(.table-nohead) tr:nth-child(odd) {
  background-color: #fff;
}

.table:not(.table-nohead) tr:nth-child(even) {
  background-color: #f9f9f9;
}

.table:not(.table-nohead) tr:hover {
  background-color: #e1e1e1;
}

table td,
table th {
  padding: 5px 5px;
}

table tr:hover {
  background-color: #e1e1e1;
}

.sortable-ghost {
  border: 1px dashed grey;
  font-size: 0;
  overflow: hidden;
}

.drag-preview {
  position: absolute;
}

input[type="text"],
input[type="number"] {
  padding: 0.125rem 0.625rem 0.25rem;
  height: 1.875rem;
  line-height: 1.125rem;
  font-size: 0.9375rem;
  background-color: #fff;
  appearance: none;
  color: #111;
  font-weight: 400;
  border: 1px solid #ccc;
  border-radius: 0.375rem;
  width: 100%;
  position: relative;
}

input:focus-visible,
input:focus {
  border-color: #2d7ff9 !important;
  border-width: 2px;
  outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="text"],
input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
